import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { HeaderList } from "../../components/HeaderList";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';


const ForecastList = () => {
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();

  const initialize = async () => { 

  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`MENU_FORECAST_ANALYSIS`)} />
      <HeaderList path={`${pathname}/add`} title={t(`EQUIPMENT_DASH_CORE_REPORT`)} />
      <HeaderList path={`${pathname}/add`} title={t(`INCONSISTENT.FORECAST_ANALYSIS`)} />
      <HeaderList path={`${pathname}/add`} title={t(`MENU_BELOW_IDEAL_PICKUP_SCHEDULING`)} />
    </>
  );
};
export default ForecastList;